require('./brokerExecutionTable.scss');

const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const moment = require('moment');
//@components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
//@constants
const { HYPHEN,
        DATE_FORMAT_COMPLETE } = require('constants/index');

class BrokerExecutionTable extends React.Component {

    constructor(props) {
        super(props);

        this.buildTable = this.buildTable.bind(this);
        this.buildTableHeader = this.buildTableHeader.bind(this);
        this.buildRow = this.buildRow.bind(this);
    }

    buildTaxAmountColumn(row) {
        const language = getLanguage();
        const plainAmountTaxesObject = getPlainAmountObject(row.get('taxAmount'));
        return(
            <td className="broker-execution-table__cell">
                <OneLineSymbolAmount
                    amountObject={plainAmountTaxesObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountTaxesObject, true)} />
            </td>)
    }

    buildRow() {
        const { immExecutionDetails, showTaxAmount } = this.props;
        return immExecutionDetails.map((row, index) => {
            const rowKey = `broker-execution-row-${index}`;
            const taxAmountCol = showTaxAmount ? this.buildTaxAmountColumn(row) : null;
            const plainAmountExchangeObject = getPlainAmountObject(row.get('exchangeSale'));
            const plainAmountGrossObject = getPlainAmountObject(row.get('grossSale'));
            const plainAmountCannonObject = getPlainAmountObject(row.get('canonSale'));
            const plainAmountComissionObject = getPlainAmountObject(row.get('commissionSale'));
            const plainAmountTotalObject = getPlainAmountObject(row.get('totalExpensesSale'));
            const plainAmountLiquidObject = getPlainAmountObject(row.get('liquidSale'));
            const language = getLanguage();
            let dateTime = HYPHEN;

            if (row.get('time') && row.get('date')) {
                dateTime = moment(`${row.get('date')} ${row.get('time')}`).format(DATE_FORMAT_COMPLETE)
            }

            return (<tr key={rowKey}>
                <td className="broker-execution-table__cell">{dateTime}</td>
                <td className="broker-execution-table__cell">{row.get('titles')}</td>
                <td className="broker-execution-table__cell">
                    <OneLineSymbolAmount
                        amountObject={plainAmountExchangeObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountExchangeObject, true)} />
                </td>
                <td className="broker-execution-table__cell">
                    <OneLineSymbolAmount
                        amountObject={plainAmountGrossObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountGrossObject, true)} />
                </td>
                <td className="broker-execution-table__cell">
                    <OneLineSymbolAmount
                        amountObject={plainAmountCannonObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountCannonObject, true)} />
                </td>
                <td className="broker-execution-table__cell">
                    <OneLineSymbolAmount
                        amountObject={plainAmountComissionObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountComissionObject, true)} />
                </td>
                {taxAmountCol}
                <td className="broker-execution-table__cell">
                    <OneLineSymbolAmount
                        amountObject={plainAmountTotalObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountTotalObject, true)} />
                </td>
                <td className="broker-execution-table__cell">
                    <OneLineSymbolAmount
                        amountObject={plainAmountLiquidObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountLiquidObject, true)} />
                </td>
            </tr>);

        });
    }

    buildTable() {
        const rows = this.buildRow();
        const head = this.buildTableHeader();

        return (
            <table className="broker-execution-table__table">
                <thead>
                    {head}
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        );
    }

    buildTableHeader() {
        const { showTaxAmount } = this.props;
        const colsArray = ['Date', 'Tit', 'Exchange', 'Gross', 'Canon', 'Commission', 'Taxes', 'TGas', 'Liquid'];
        const toolTipText = (
            <FormattedText value={`broker-executionTableTaxesTooltip`}/>

        );
        const tooltTipTaxes = (<OKTooltip content={toolTipText} placement="right" />);
        const headerTaxes = (
            <FormattedTextWithComponents
                value={'broker-executionTableTaxes'}
                injectedComponents={[tooltTipTaxes]}
            />
        );

        let cols = colsArray.map((col, index) => {
            const colKey=`execution-table-column-${index}`;
            let colContent;
            if (col === 'Taxes') {
                colContent = showTaxAmount ? (
                    <th key={colKey}>
                        {headerTaxes}
                    </th>
                ) : null;
            }
            else {
                colContent = (
                    <th key={colKey} className="broker-execution-table__cell-header">
                        <FormattedText value={`broker-executionTable${col}`} format="uppercase" />
                    </th>
                );
            }
            return colContent;
        });

        return (
            <tr>
                {cols}
            </tr>
        );
    }

    render() {
        const table = this.buildTable();

        return (
            <article className="broker-execution-table">
                <header className="broker-execution-table__title">
                    <FormattedText value="broker-executionTableTitle" />
                </header>
                <div className="broker-execution-table__separator" />
                <section className="broker-execution-table__body">
                    {table}
                </section>
            </article>
        );
    }
}

BrokerExecutionTable.propTypes = {
    immExecutionDetails: PropTypes.object.isRequired,
    showTaxAmount: PropTypes.boolean,
};

BrokerExecutionTable.defaultProps = {
    showTaxAmount: false,
};

module.exports = BrokerExecutionTable;
